import { render } from "./deleteCommercial.vue?vue&type=template&id=4fbe3f4b&scoped=true"
import script from "./deleteCommercial.vue?vue&type=script&lang=js"
export * from "./deleteCommercial.vue?vue&type=script&lang=js"

import "./deleteCommercial.vue?vue&type=style&index=0&id=4fbe3f4b&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbe3f4b"]])

export default __exports__